<header
  id="header"
  class="fixed-top"
  [class.has-side-menu]="hasSideMenu || layout?.sideMenu?.hasClass"
  [class.bg-mobile-transparent]="layout?.header?.bgTransparentMobile"
  [class.bg-mobile-blur]="layout?.header?.bgBlurMobile"
  [class.bg-color]="layout?.main?.hasBgColor"
  [class.d-none]="layout?.header?.hidden"
>
  <div
    class="header-wrapper"
    [ngClass]="{ 'd-none d-md-block border-bottom': !simple }"
    [class.border-sm-bottom]="layout?.sideMenu?.hasClass"
  >
    <div
      class="h-100 d-flex align-items-center gpx-24 gpl-md-20"
      [class.gpr-md-56]="layout?.header?.skipLink?.show"
    >
      <div
        *ngIf="hasSideMenu && !isCollapsable && !isCheckout"
        class="pointer hamburger gpr-24"
        (click)="openSideMenu()"
      >
        <i class="gpicon-hamburger-2"></i>
      </div>

      <div
        class="pointer me-auto"
        (click)="redirectToWebsiteOrDashboard()"
        [ngClass]="{
          'visibility-mobile-hidden': layout?.header?.hideMobileLogo
        }"
        [style.pointer-events]="
          layout?.header?.preventClickOnLogo ? 'none' : 'auto'
        "
      >
        <picture>
          <source
            media="(min-width:576px)"
            srcset="/assets/images/geneplanet.svg"
          />
          <img
            src="/assets/images/geneplanet-logo.svg"
            height="16px"
            alt="Geneplanet Logo"
          />
        </picture>
      </div>

      <ng-container *ngIf="!simple && !isCheckout">
        @if ('shop' | isFeatureActive) {
          <div class="nav-item gp-8 gmr-16">
            <gps-cart-count-badge
              icon="gpicon-cart-2"
              activeIcon="gpicon-cart-2-filled"
              badgeClass="p6-semibold"
              (click)="onNavItemClicked()"
            />
          </div>
        }

        <div class="nav-item gp-8">
          <a
            routerLink="/me"
            routerLinkActive="active"
            (click)="onNavItemClicked()"
          >
            <i
              [ngClass]="
                isRouterLinkActive('/me')
                  ? 'gpicon-profile-filled'
                  : 'gpicon-profile'
              "
            ></i>
          </a>
        </div>
      </ng-container>

      <button
        class="btn-close m-0"
        *ngIf="layout?.header?.closeButton"
        (click)="onClose()"
      >
        <i class="gpicon-close"></i>
      </button>

      <button
        class="gbtn-4 gbtn-sq b3-semibold gpx-16 gpy-4"
        *ngIf="layout?.header?.cancelIntent"
        (click)="onClose()"
      >
        {{ 'ONBOARDING.COMPLETE.CLOSE' | translate }}
      </button>

      <span
        *ngIf="layout?.header?.skipLink?.show"
        class="text-gray b2-semibold"
        role="button"
        (click)="onSkipClick()"
        gptDataTrack="onboarding-header-skip"
      >
        {{ 'ONBOARDING.HEADER.SKIP' | translate }}
      </span>

      <app-header-language-switcher
        *ngIf="layout?.header?.languageSelector"
      ></app-header-language-switcher>

      <button
        *ngIf="!!account && layout?.header?.logOutButton"
        (click)="logout()"
        class="gbtn-3 gbtn-sq gbtn-sm ms-auto"
        [ngClass]="'b2-semibold' | gpuMediaQuery: 'b3-semibold'"
        gptDataTrack="onboarding-header-logout"
      >
        {{ 'ME.LOGOUT' | translate }}
      </button>
    </div>
  </div>
</header>
